import React, { ReactElement } from 'react';
import styled from 'styled-components';
import ReactIcon from '@mdi/react';
import {
  mdiClose,
  mdiPlayCircleOutline,
  mdiPlay,
  mdiContentCopy,
  mdiPencil,
  mdiPlus,
  mdiMagnify,
  mdiViewDay,
  mdiViewGrid,
  mdiDrag,
  mdiArrowLeft,
  mdiArrowRight,
  mdiEye,
  mdiEyeOff,
  mdiMenu,
  mdiCubeOutline,
  mdiLocationExit,
  mdiCogOutline,
  mdiText,
  mdiFormatListNumbered,
  mdiChevronUp,
  mdiChevronDown,
  mdiChevronLeft,
  mdiChevronRight,
  mdiViewDashboard,
  mdiInvertColors,
  mdiInvertColorsOff,
  mdiFormatFontSizeIncrease,
  mdiFormatFontSizeDecrease,
  mdiChevronDoubleRight,
  mdiFullscreen,
  mdiFullscreenExit,
  mdiInformationOutline,
  mdiCardTextOutline,
  mdiPlayBoxOutline,
  mdiCheckboxOutline,
  mdiCommentQuestion,
  mdiCommentQuestionOutline,
  mdiAlertCircle,
  mdiCheck,
  mdiLock,
  mdiThumbDown,
  mdiThumbUp,
  mdiOpenInNew,
  mdiFacebook,
  mdiTwitter,
  mdiLinkedin,
  mdiInstagram,
  mdiCalendarClock,
  mdiDownload,
  mdiLoading,
  mdiCreditCardOutline,
  mdiBarcode,
  mdiTimer,
  mdiQrcodeScan,
  mdiShieldLock,
  mdiShieldCheck,
  mdiCellphone,
  mdiEmailAlertOutline,
  mdiFileDocumentOutline,
  mdiBank,
  mdiViewSequential,
  mdiAccount,
  mdiFilterVariant,
  mdiCalendarRemove,
  mdiCalendarRemoveOutline,
  mdiEmailFast,
  mdiWhatsapp,
  mdiCalendar,
  mdiCalculator,
  mdiClockTimeFourOutline,
  mdiFormatListBulleted,
  mdiCloseCircleOutline,
  mdiCancel,
  mdiHeart,
  mdiRefresh,
  mdiCloseCircle,
  mdiRadioboxBlank,
  mdiCheckboxMarkedCircle,
  mdiRadioboxMarked,
  mdiCheckboxMarkedCircleOutline,
  mdiArrowDown,
  mdiLockOutline,
  mdiArrowUp,
  mdiTextBoxOutline,
  mdiTimerOutline,
  mdiTrayArrowDown,
  mdiProgressDownload,
  mdiTimerSandComplete,
  mdiCurrencyUsd,
  mdiDelete,
  mdiYoutube,
  mdiCalendarCheckOutline,
  mdiCalendarAlertOutline,
  mdiAccountCancel,
  mdiAccountCheck,
  mdiAccountArrowRight,
  mdiMenuDown,
  mdiMenuUp,
  mdiEmailOpenOutline,
  mdiEmailOutline,
  mdiPrinter,
  mdiInbox,
  mdiArchiveOutline,
  mdiTrashCanOutline,
  mdiSwapVertical,
  mdiMessageReply,
  mdiArrowRightTop,
  mdiFilePdfBox,
  mdiShieldAlertOutline,
  mdiArrowRightThin,
  mdiSquareEditOutline,
} from '@mdi/js';

import { IconProps } from './types';

const Icon = styled(ReactIcon)``;

const Icons = ({ icon, ...props }: IconProps): ReactElement => {
  let path: string;

  switch (icon) {
    case 'closeOutline':
      path = mdiCloseCircleOutline;
      break;

    case 'close':
      path = mdiClose;
      break;

    case 'refresh':
      path = mdiRefresh;
      break;

    case 'copy':
      path = mdiContentCopy;
      break;

    case 'edit':
      path = mdiPencil;
      break;

    case 'plus':
      path = mdiPlus;
      break;

    case 'cancel':
      path = mdiCancel;
      break;

    case 'play':
      path = mdiPlay;
      break;

    case 'playOutline':
      path = mdiPlayCircleOutline;
      break;

    case 'playBoxOutline':
      path = mdiPlayBoxOutline;
      break;

    case 'listView':
      path = mdiViewDay;
      break;

    case 'gridView':
      path = mdiViewGrid;
      break;

    case 'drag':
      path = mdiDrag;
      break;

    case 'arrowLeft':
      path = mdiArrowLeft;
      break;

    case 'commentQuestion':
      path = mdiCommentQuestion;
      break;

    case 'commentQuestionOutline':
      path = mdiCommentQuestionOutline;
      break;

    case 'filePdfBox':
      path = mdiFilePdfBox;
      break;

    case 'arrowRight':
      path = mdiArrowRight;
      break;

    case 'textBoxOutline':
      path = mdiTextBoxOutline;
      break;

    case 'arrowDown':
      path = mdiArrowDown;
      break;

    case 'chevronDoubleRight':
      path = mdiChevronDoubleRight;
      break;

    case 'arrowUp':
      path = mdiArrowUp;
      break;

    case 'eye':
      path = mdiEye;
      break;

    case 'clockTimeFourOutline':
      path = mdiClockTimeFourOutline;
      break;

    case 'formatListBulleted':
      path = mdiFormatListBulleted;
      break;

    case 'calendarClock':
      path = mdiCalendarClock;
      break;

    case 'fileDocumentOutline':
      path = mdiFileDocumentOutline;
      break;

    case 'shieldAlertOutline':
      path = mdiShieldAlertOutline;
      break;

    case 'accountArrowRight':
      path = mdiAccountArrowRight;
      break;

    case 'eyeOff':
      path = mdiEyeOff;
      break;

    case 'heart':
      path = mdiHeart;
      break;

    case 'like':
      path = mdiThumbUp;
      break;

    case 'emailFast':
      path = mdiEmailFast;
      break;

    case 'alertCircle':
      path = mdiAlertCircle;
      break;

    case 'unlike':
      path = mdiThumbDown;
      break;

    case 'menu':
      path = mdiMenu;
      break;

    case 'squareEditOutline':
      path = mdiSquareEditOutline;
      break;

    case 'cube':
      path = mdiCubeOutline;
      break;

    case 'filter':
      path = mdiFilterVariant;
      break;

    case 'calculator':
      path = mdiCalculator;
      break;

    case 'calendar':
      path = mdiCalendar;
      break;

    case 'calendarRemove':
      path = mdiCalendarRemove;
      break;

    case 'calendarRemoveOutline':
      path = mdiCalendarRemoveOutline;
      break;

    case 'calendarCheckOutline':
      path = mdiCalendarCheckOutline;
      break;

    case 'calendarAlertOutline':
      path = mdiCalendarAlertOutline;
      break;

    case 'exit':
      path = mdiLocationExit;
      break;

    case 'gear':
      path = mdiCogOutline;
      break;

    case 'youtube':
      path = mdiYoutube;
      break;

    case 'chevronLeft':
      path = mdiChevronLeft;
      break;

    case 'checkboxOutline':
      path = mdiCheckboxOutline;
      break;

    case 'radioboxBlank':
      path = mdiRadioboxBlank;
      break;

    case 'chevronRight':
      path = mdiChevronRight;
      break;

    case 'chevronDown':
      path = mdiChevronDown;
      break;

    case 'chevronUp':
      path = mdiChevronUp;
      break;

    case 'text':
      path = mdiText;
      break;

    case 'download':
      path = mdiDownload;
      break;

    case 'arrowRightThin':
      path = mdiArrowRightThin;
      break;

    case 'trayDownload':
      path = mdiTrayArrowDown;
      break;

    case 'progressDownload':
      path = mdiProgressDownload;
      break;

    case 'loading':
      path = mdiLoading;
      break;

    case 'timerSandComplete':
      path = mdiTimerSandComplete;
      break;

    case 'accountCancel':
      path = mdiAccountCancel;
      break;

    case 'accountCheck':
      path = mdiAccountCheck;
      break;

    case 'checkboxMarkedCircleOutline':
      path = mdiCheckboxMarkedCircleOutline;
      break;

    case 'radioboxMarked':
      path = mdiRadioboxMarked;
      break;

    case 'textOutline':
      path = mdiCardTextOutline;
      break;

    case 'quiz':
      path = mdiFormatListNumbered;
      break;

    case 'lock':
      path = mdiLock;
      break;

    case 'lockOutline':
      path = mdiLockOutline;
      break;

    case 'dashboard':
      path = mdiViewDashboard;
      break;

    case 'themeLight':
      path = mdiInvertColors;
      break;

    case 'themeDark':
      path = mdiInvertColorsOff;
      break;

    case 'fontUp':
      path = mdiFormatFontSizeIncrease;
      break;

    case 'delete':
      path = mdiDelete;
      break;

    case 'fontDown':
      path = mdiFormatFontSizeDecrease;
      break;

    case 'openInNew':
      path = mdiOpenInNew;
      break;

    case 'fullscreenOff':
      path = mdiFullscreenExit;
      break;

    case 'info':
      path = mdiInformationOutline;
      break;

    case 'fullscreenOn':
      path = mdiFullscreen;
      break;

    case 'facebook':
      path = mdiFacebook;
      break;

    case 'twitter':
      path = mdiTwitter;
      break;
    case 'linkedin':
      path = mdiLinkedin;
      break;

    case 'instagram':
      path = mdiInstagram;
      break;

    case 'creditCard':
      path = mdiCreditCardOutline;
      break;

    case 'barcode':
      path = mdiBarcode;
      break;

    case 'closeCircle':
      path = mdiCloseCircle;
      break;

    case 'timer':
      path = mdiTimer;
      break;

    case 'timerOutline':
      path = mdiTimerOutline;
      break;

    case 'qrcode':
      path = mdiQrcodeScan;
      break;

    case 'shieldLock':
      path = mdiShieldLock;
      break;

    case 'shieldCheck':
      path = mdiShieldCheck;
      break;

    case 'checkedOutline':
      path = mdiCheckboxMarkedCircle;
      break;

    case 'cellphone':
      path = mdiCellphone;
      break;

    case 'emailAlertOutline':
      path = mdiEmailAlertOutline;
      break;

    case 'sequentialView':
      path = mdiViewSequential;
      break;

    case 'bank':
      path = mdiBank;
      break;

    case 'account':
      path = mdiAccount;
      break;

    case 'whatsapp':
      path = mdiWhatsapp;
      break;

    case 'check':
      path = mdiCheck;
      break;

    case 'currencyUsd':
      path = mdiCurrencyUsd;
      break;

    case 'search':
      // default:
      path = mdiMagnify;
      break;
    case 'menuUp':
      path = mdiMenuUp;
      break;

    case 'menuDown':
      path = mdiMenuDown;
      break;
    case 'emailOpen':
      path = mdiEmailOpenOutline;
      break;
    case 'email':
      path = mdiEmailOutline;
      break;
    case 'printer':
      path = mdiPrinter;
      break;
    case 'inbox':
      path = mdiInbox;
      break;
    case 'archive':
      path = mdiArchiveOutline;
      break;
    case 'trash':
      path = mdiTrashCanOutline;
      break;

    case 'swap':
      path = mdiSwapVertical;
      break;

    case 'reply':
      path = mdiMessageReply;
      break;
    case 'arrowRightTop':
      path = mdiArrowRightTop;
      break;
  }

  return path ? <Icon path={path} {...props} /> : <></>;
};

export default Icons;
